document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.trusted__slider').forEach(function (sliderEl) {
    try {
      const slides = sliderEl.querySelectorAll('.splide__slide');
      const slideCount = slides.length;
      
      if (slideCount === 0 || slideCount <= 3) return;
      
      const splide = new Splide(sliderEl, {
        type: 'slide',
        pagination: false,
        arrows: false,
        drag: true,
        gap: '0',
        autoWidth: true,
        center: true,
        perMove: 1,
        trimSpace: true,
        freeMode: true,
      });

      const list = sliderEl.querySelector('.splide__list');
      let isScrolling = false;

      function setScrollMargins() {
        const allSlides = sliderEl.querySelectorAll('.splide__slide');
        allSlides.forEach(function(slide) {
          slide.style.removeProperty('margin-inline');
          slide.style.setProperty('margin-inline', '0px', 'important');
          slide.style.setProperty('margin-right', '24px', 'important');
        });
      }

      function setCenterMargins() {
        const allSlides = sliderEl.querySelectorAll('.splide__slide');
        allSlides.forEach(function(slide) {
          slide.style.removeProperty('margin-right');
          slide.style.setProperty('margin-inline', '12px', 'important');
        });
      }

      function removeJustifyContent() {
        if (list) {
          list.style.removeProperty('justify-content');
          list.style.setProperty('justify-content', 'unset', 'important');
        }
      }

      function setJustifyContentCenter() {
        if (list) {
          list.style.setProperty('justify-content', 'center', 'important');
        }
      }

      function checkIfScrollable() {
        const track = sliderEl.querySelector('.splide__track');
        if (!track || !list) return;
        
        setTimeout(function() {
          const trackWidth = track.offsetWidth;
          const listWidth = list.scrollWidth;
          
          if (listWidth <= trackWidth) {
            setJustifyContentCenter();
            setCenterMargins();
          } else {
            if (isScrolling) {
              removeJustifyContent();
              setScrollMargins();
            }
          }
        }, 100);
      }

      splide.on('mounted', function() {
        checkIfScrollable();
      });

      splide.on('resize', function() {
        checkIfScrollable();
      });

      splide.on('drag', function() {
        isScrolling = true;
        removeJustifyContent();
        setScrollMargins();
      });

      splide.on('move', function() {
        isScrolling = true;
        removeJustifyContent();
        setScrollMargins();
      });

      splide.on('moved', function() {
        setTimeout(function() {
          isScrolling = false;
        }, 100);
      });

      splide.mount();
    } catch (e) {
      console.error('Trusted section slider error:', e);
    }
  });
});